import BaseCRUDService from './BaseCRUDService';

class ProtocoloService extends BaseCRUDService {
  getBaseURL = () => {
    return '~/api/protocol';
  };
}

export default new ProtocoloService();
